import { Link } from 'react-router-dom'
import { useEffect, useRef } from 'react'
import './Equipment.css'
import equipmentVideo from '../assets/UniFi Networking Innovations_ Site Manager _ Network 8.3 _ Cloud Gateway Max.mp4'

function EquipmentPage({ t }) {
  const { title, lead, items, linkLabel } = t.equipment
  const videoRef = useRef(null)

  useEffect(() => {
    const video = videoRef.current
    if (video) {
      console.log('Video element:', video)
      console.log('Video source:', equipmentVideo)

      const handleLoadedData = () => {
        console.log('Video loaded successfully')
        video.play().catch(error => {
          console.log('Video autoplay failed:', error)
        })
      }

      const handleError = (e) => {
        console.error('Video error:', e)
        console.error('Video error code:', video.error)
      }

      video.addEventListener('loadeddata', handleLoadedData)
      video.addEventListener('error', handleError)

      // Force load
      video.load()

      return () => {
        video.removeEventListener('loadeddata', handleLoadedData)
        video.removeEventListener('error', handleError)
      }
    }
  }, [])

  return (
    <div className="page">
    <section className="section equipment-page">
      {/* Video Hero Section */}
      <div className="equipment-video-hero">
        <div className="equipment-video-background">
          <video
            ref={videoRef}
            className="equipment-video"
            autoPlay
            loop
            muted
            playsInline
            preload="metadata"
            src={equipmentVideo}
          >
            Your browser does not support the video tag.
          </video>
          <div className="equipment-video-overlay"></div>
        </div>
        <div className="equipment-video-content">
          <h2>{title}</h2>
          <p>{lead}</p>
        </div>
      </div>

      <div className="equipment-carousel">
        <div className="equipment-grid">
          {items.map((item) => {
            const initials = item.name
              .split(' ')
              .filter(Boolean)
              .slice(0, 2)
              .map((word) => word[0].toUpperCase())
              .join('')

            return (
              <article className="equipment-card" key={item.slug}>
                <div className="equipment-card-media" aria-hidden="true">
                  <span>{initials}</span>
                </div>
                <div className="equipment-card-content">
                  <div className="equipment-card-header">
                    <h3>{item.name}</h3>
                    <span className="equipment-price">{item.price}</span>
                  </div>
                  <p className="equipment-description">{item.description}</p>
                  <div className="equipment-actions">
                    <Link className="equipment-link" to={`/equipment/${item.slug}`}>
                      {linkLabel}
                    </Link>
                  </div>
                </div>
              </article>
            )
          })}
        </div>
      </div>
    </section>
    </div>
  )
}

export default EquipmentPage
